<template>
  <div class="orderDetailBtn">
    <p>{{title}}</p>
  </div>
</template>
<script>
export default {
  props: {
    title: {
      type: String,
      default: "返回"
    }
  },
  methods: {
    // 返回到列表
    GoBack(value) {
      window.history.back(-1); 
    },
  }
};
</script>
<style lang="scss" scoped>
@import "~@/scss/libs.scss";
.orderDetailBtn {
  flex: 1;
  width: 100%;
  font-size: 0;
  p {
    height: px2rem(88);
    line-height: px2rem(88);
    color: white;
    text-align: center;
    font-size: px2rem(30);
  }
  &:first-child {
    background: #00a0e9;
  }
  &:nth-child(2) {
    background: $shallowRed;
  }
  &:last-child {
    background: $cyan;
  }
}
</style>
